// The cases touching a workspace's traces, as the chat shows them when asked
// (board_cases' details, lib/chatSubject.js: { board, sessions, focusCaseId,
// range }): the case list (CaseInbox), read as the card opens, the
// workspace's own case first, each case with Dig, Take it and Let go. The
// cases it lists are the chat's (lib/chatShownCases.js, by the call that
// showed them, `nodeId`): the reader asks about them without adding them. A
// case's notes point at their pins on the board, and a session it names
// comes into view or is laid on the workspace.
import { Suspense, lazy, useCallback } from "react";
import { showChatCases } from "../lib/chatShownCases.js";
import { layOnTraceCanvas } from "../lib/traceCanvasStore.js";
import { openWorkspaceNote, pointWorkspaceNote, requestWorkspaceFocus, useWorkspaceNotesPointed } from "../lib/workspaceStore.js";

const CaseInbox = lazy(() => import("./CaseInbox.jsx"));

export default function BoardCasesCard({ details, nodeId = null }) {
  const pointed = useWorkspaceNotesPointed();
  const onShown = useCallback((entries) => { if (nodeId) showChatCases(nodeId, entries); }, [nodeId]);
  const board = details?.board || null;
  const onFocus = useCallback(({ session, noteId = null }) => {
    if (noteId) openWorkspaceNote(noteId);
    else if (session) requestWorkspaceFocus(session);
  }, []);
  const onLayOn = useCallback((session) => { if (board) layOnTraceCanvas(board, [session]); }, [board]);
  const sessions = Array.isArray(details?.sessions) ? details.sessions : [];
  if (!sessions.length) return null;
  return (
    <div data-board-cases="" className="min-w-0 rounded-[2px] border border-[color:var(--line-soft)]">
      <Suspense fallback={null}>
        <CaseInbox
          mode="dock"
          steer={`session:${sessions.join(",")}`}
          range={details.range}
          focusCaseId={details.focusCaseId || null}
          onBoard={sessions}
          onFocus={onFocus}
          onLayOn={board ? onLayOn : null}
          pointed={pointed}
          onPoint={pointWorkspaceNote}
          inChat
          onShown={onShown}
        />
      </Suspense>
    </div>
  );
}
